import { makeStyles } from 'tss-react/mui'
const BaseLayoutHeaderStyle = makeStyles()((theme: any) => ({
  expirePasswordImpersonateStaffLoginContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  expirePasswordImpersonateContainer: {
    display: 'flex',
    top: '35px',
    position: 'relative',
    [theme.breakpoints.between(0, 600)]: {
      flexDirection: 'column',
      top: '29px',
    },
  },
  expirePasswordLink: {
    textAlign: 'left',
    top: '-5px',
    marginBottom: '6.4px',
    marginRight: '48px',
    [theme.breakpoints.between(0, 600)]: {
      marginRight: '0px',
    },
  },
  staffLogin: {
    textAlign: 'right',
    position: 'relative',
    top: '-5px',
    display: 'flex',
    alignSelf: 'flex-end',
    marginBottom: '6.4px',
  },
}))

export default BaseLayoutHeaderStyle
